export const HASH_MAIN_CONTENT              = "#main__content";
export const BASE_URL                       = { pathname: '/'};
export const PRICE_URL                      = { pathname:'/price'};
export const FAQ_INSTALL_URL                = { pathname:'/faq'};
//export const RETURN_POLICY_URL              = { pathname:'/return-policy', hash: HASH_MAIN_CONTENT};
export const COOKIE_POLICY_URL              = { pathname:'/cookie-policy'};
export const PRIVACY_POLICY_URL             = { pathname:'/privacy-policy'};
export const TERMS_CONDITIONS_URL           = { pathname:'/terms-conditions'};
export const KEYMAKER_URL                   = { pathname:'/key-maker'};
export const GET_PLUGIN_URL                 = { pathname:'/plugin'};
export const REFERRAL_URL                   = { pathname: '/referral'};
export const ADOBE_RATING_URL               = { pathname: '/adobe/rating'}

/* AUTHORISATION */
export const RESET_PASS_CONFIRM_URL         = { pathname:'/account/password/confirm/*'};
export const RESET_PASS_REJECT_URL          = { pathname:'/account/password/reject/*'};
export const LOGIN_URL                      = { pathname:'/login'};
export const SIGNUP_URL                     = { pathname:'/signup'};
export const ACTIVATED_SUCCESS_URL          = { pathname:'/activate/success'};

/* USER */
export const USER_URL                       = { pathname:'/user'};
//export const USER_BILLS_URL                 = { pathname: USER_URL.pathname.concat('/bills')};
export const USER_SETTINGS_URL              = { pathname: USER_URL.pathname.concat('/settings')};
export const USER_PASSWORD_URL              = { pathname: USER_URL.pathname.concat('/password')};
export const USER_REFERRAL_URL              = { pathname: USER_URL.pathname.concat(REFERRAL_URL.pathname)};
export const USER_BRIEFS_URL                = { pathname: USER_URL.pathname.concat('/briefs')};
export const USER_ADOBE_RATING_URL          = { pathname: USER_URL.pathname.concat(ADOBE_RATING_URL.pathname)};

/* ADMIN */
export const USERS_URL                      = { pathname:'/users'};
export const MANAGEMENT_SETTINGS_URL        = { pathname:'/management/settings'};
 
export const ADMIN_URL                      = { pathname:'/admin'};
export const ADMIN_USERS_URL                = { pathname: ADMIN_URL.pathname.concat(USERS_URL.pathname), search: '?page=1&limit=30'};
export const ADMIN_LOGIN_URL                = { pathname: ADMIN_URL.pathname.concat(LOGIN_URL.pathname)};
//export const ADMIN_USER_BILLS_URL           = { pathname: ADMIN_URL.pathname.concat(USER_BILLS_URL.pathname), search: '?page=1&limit=20'};
export const ADMIN_USER_SETTINGS_URL        = { pathname: ADMIN_URL.pathname.concat(USER_SETTINGS_URL.pathname)};
export const ADMIN_USER_PASSWORD_URL        = { pathname: ADMIN_URL.pathname.concat(USER_PASSWORD_URL.pathname)};
export const ADMIN_USER_REFERRAL_URL        = { pathname: ADMIN_URL.pathname.concat(USER_REFERRAL_URL.pathname)};
export const ADMIN_USER_BRIEFS_URL          = { pathname: ADMIN_URL.pathname.concat(USER_BRIEFS_URL.pathname)};
export const ADMIN_MANAGEMENT_SETTINGS_URL  = { pathname: ADMIN_URL.pathname.concat(MANAGEMENT_SETTINGS_URL.pathname)};
export const ADMIN_ADOBE_RATING_URL         = { pathname: ADMIN_URL.pathname.concat(USER_ADOBE_RATING_URL.pathname), search: '?page=1&limit=20' };
 
export const NOT_FOUND_URL                  = { pathname: '*'};
